if (!customElements.get('sticky-add-to-cart')) {
  class StickyAddToCart extends HTMLElement {
    constructor() {
      super()

      this.options = {}

      this.containerEl = this.closest('.sticky-add-to-cart') || this.parentElement
      this.mainProductInfoSectionEl = document.querySelector('section[id^="MainProduct-"]')
      this.productFormEl = this.mainProductInfoSectionEl.querySelector('product-form')

      this.reviewsEl = document.querySelector('.oke-w-reviews-controls')

      if (!this.productFormEl) {
        console.error('Product form element not found')
        return
      }

      this.productFormBottom = this.productFormEl.getBoundingClientRect().bottom

      if (this.reviewsEl) {
        this.reviewsTop = this.reviewsEl.getBoundingClientRect().top
      }

      // this.updateActiveState(true);

      const intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback.bind(this), this.options)

      intersectionObserver.observe(this.productFormEl)
    }

    intersectionObserverCallback(entries, observer) {
      entries.forEach((entry) => {
        this.containerEl?.classList.toggle('active', !entry.isIntersecting)
      })
    }
  }

  customElements.define('sticky-add-to-cart', StickyAddToCart)
}
